import { FC } from 'react';
import styled from 'styled-components';

import { CloseButton, StyledDialog } from '@/components/AlertDialogs/Dialog';
import { Modal } from '@/components/Modal';
import Text from '@/components/Text';

import UploadMultipleImages from './UploadMultipleImages';
import { ImageData } from './VariationOne';

const Dialog = styled(StyledDialog)`
  width: 600px;
  padding: 0;
  text-align: left;
`;

const ModalContent = styled.div`
  padding: 24px;
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 4px;
  padding: 24px;
  position: relative;
  box-shadow: 0px 2px 8px rgba(34, 34, 34, 0.06);
`;

interface Props {
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
  onClose: () => void;
  noneDivider?: boolean;
  blackDivider?: boolean;
  quotes?: boolean;
  coverIndex: number;
}

const MoreImagesModal: FC<Props> = ({
  onClose,
  setImages,
  noneDivider,
  blackDivider,
  quotes = true,
  coverIndex,
}) => {
  return (
    <Modal zIndex={1}>
      <Dialog
        initial={{ scale: 0.5 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.5 }}
      >
        <ModalHeader>
          <Text $type="button">Add More Images</Text>
          <CloseButton onClick={onClose}>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1L1 13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13 13L1 1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CloseButton>
        </ModalHeader>
        <ModalContent>
          <UploadMultipleImages
            isInModal
            noneDivider={noneDivider}
            blackDivider={blackDivider}
            setImages={setImages}
            onClose={onClose}
            coverIndex={coverIndex}
            quotes={quotes}
          />
        </ModalContent>
      </Dialog>
    </Modal>
  );
};

export default MoreImagesModal;
